import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { APIServiceProvider } from "./../../common/services/api.service";

import { HelperServiceProvider } from "./../../common/services/helper.service";

import { TabAddOrder } from "./../addorder/tabs/tab-addorder";

import { NotifyService } from "../../services/notify.service";

@Component({
  selector: "page-farmers",
  templateUrl: "farmers.html"
})
export class FarmersPage {
  public getCustomersUrl = "customer/get-fieldstaff-customers";
  public postParams = {
    created_by: localStorage.getItem("user-id"),
    limit: 10
  };
  public farmersData = [];
  public pagination = null;
  public searchText = null;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public helperService: HelperServiceProvider,
    public apiHelper: APIServiceProvider,
    private notifyService: NotifyService
  ) {
    this.notifyService.customerSaved.subscribe(() => {
      this.getFarmers(this.getCustomersUrl);
    });
  }

  ionViewDidLoad() {
    this.getFarmers(this.getCustomersUrl);
  }

  goToAddOrder(former) {
    this.navCtrl.push(TabAddOrder, {
      mobile_no: former.mobile_no,
      action_type: "Update Farmer"
    });
  }

  getFarmers(url, refresh?) {
    this.apiHelper.post(url, this.postParams).subscribe(response => {
      this.farmersData = response["data"]["data"];
      this.pagination = response["data"];
      if (refresh) {
        refresh.complete();
      }
    });
  }

  addFarmer() {
    this.navCtrl.push(TabAddOrder, { action_type: "Add Farmer" });
  }

  doRefresh(refresher) {
    this.getFarmers(this.getCustomersUrl, refresher);
  }

  doInfiniteScroll(event) {
    if (
      !this.pagination.next_page_url ||
      this.pagination.next_page_url === "" ||
      this.pagination.next_page_url === null ||
      this.pagination.next_page_url === "null"
    ) {
      event.complete();
      return;
    } else {
      this.apiHelper
        .post(null, this.postParams, this.pagination["next_page_url"])
        .subscribe(response => {
          this.farmersData = this.farmersData.concat(response["data"]["data"]);
          this.pagination = response["data"];
          event.complete();
        });
      return;
    }
  }

  searchFarmer(text) {
    this.postParams["search"] = this.searchText;
    this.getFarmers(this.getCustomersUrl);
  }

  clearSearch(text) {
    delete this.postParams["search"];
    this.getFarmers(this.getCustomersUrl);
  }
}



// WEBPACK FOOTER //
// ./src/pages/farmers/farmers.ts